import uuid from 'uuid';
import {UsersActionType} from '../actions/users';
import {emptyWebUsersFilter, WebUserRow, WebUsersCursor, WebUsersFilter} from '../models/WebUser';
import {WebsocketAction} from '../models/Websockets';

export interface UsersState {
    /** Regenerated on every filter change; responses carrying a different stateId are ignored. */
    stateId: string;
    users: WebUserRow[];
    filter: WebUsersFilter;
    isLoading: boolean;
    hasMore: boolean;
    nextCursor: WebUsersCursor | null;
}

const getInitialState = (): UsersState => ({
  stateId: uuid.v4(),
  users: [],
  filter: emptyWebUsersFilter(),
  isLoading: false,
  hasMore: false,
  nextCursor: null,
});

export default function users(state = getInitialState(), action: any): UsersState {
  switch (action.type) {
    case UsersActionType.IS_LOADING_USERS:
      return Object.assign({}, state, {isLoading: action.isLoading});

    case UsersActionType.SET_USERS_FILTER:
      // Rows are dropped here, not when the response arrives: the table must not show a mix of
      // the old and the new filter while the request is in flight.
      return Object.assign({}, state, {
        filter: action.filter,
        stateId: action.stateId,
        users: [],
        nextCursor: null,
        hasMore: false,
      });

    case UsersActionType.RESET_USERS:
      return Object.assign({}, getInitialState(), {stateId: action.stateId});

    case WebsocketAction.WEB_USERS_RESULT.name: {
      const payload = action.data?.message ?? {};
      if (payload.stateId && payload.stateId !== state.stateId) {
        return state;
      }
      return Object.assign({}, state, {
        users: state.users.concat(payload.users ?? []),
        hasMore: Boolean(payload.hasMore),
        nextCursor: payload.nextCursor ?? null,
        isLoading: false,
      });
    }

    default:
      return state;
  }
}
